<ng-container *transloco="let _t">

    <div [class]="'box '+module" *ngFor="let module of modules; let i=index">
      <div class="title">
        <h3><mat-icon>{{icons[i]}}</mat-icon> &nbsp; {{ _t('menu-'+module) }}</h3>
        <h5>{{ _t('intro-'+module+'-desc')}}</h5>
      </div>
        <ol>
            <li class="step1">
                <p class="vcenter">{{ _t('intro-'+module+'-step1')}}</p>
            </li>

            <li class="step2">
                <p class="vcenter">{{ _t('intro-'+module+'-step2')}}</p>
            </li>

            <li class="step3">
                <p class="vcenter">{{ _t('intro-'+module+'-step3')}}</p>
            </li>

            <li class="step4">
                <p class="vcenter">{{ _t('intro-'+module+'-step4')}}</p>
            </li>
        </ol>
    </div>
